import { fetchWithLoader } from "./api";

export async function favunfav(data: { d_id: string,user_id:string,type:string }, showToast: (msg: string, toasttype: string) => void) {
    const pad = (n: number) => n.toString().padStart(2, '0');
    const now = new Date();
    const formattedDate = `${pad(now.getDate())}-${pad(now.getMonth() + 1)}-${now.getFullYear()} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
    if (!data || data.d_id === "0") {
        showToast("Invalid drama data", "error");
        return false;
    }
    const obj = {
        ...data,
        a_id: "",
        cc: "",
        lc: "",
        mobile_dt: formattedDate
    }
    try {
        const response = await fetchWithLoader("drama_fav_unfav.php", {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify(obj)
        });

        const result = await response.json();

        if (result.data.ErrorCode === 0 || result.data.ErrorCode === 1) {
            showToast(result.data.ErrorMessage, "success")
            return true;
        } else {
            showToast(result.data.ErrorMessage, "error")
            return false;
        }
    } catch (error) {
        console.error("API call failed:", error);
        showToast("Something went wrong", "error")
        return false;
    }
}
